import { Link } from "react-router-dom";
import { Route as RouteIcon, ArrowRight } from "lucide-react";

export default function VettingHubCard() {
  return (
    <Link to="/vetting" data-testid="hub-vetting-card"
          className="group block rounded-2xl bg-white p-5 sm:p-6 ring-1 ring-[#C9A961]/40 hover:ring-[#C9A961] transition-shadow shadow-sm">
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-xl bg-[#0A1F44] text-[#C9A961] flex items-center justify-center shrink-0">
          <RouteIcon className="w-6 h-6" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] uppercase tracking-[0.24em] text-[#C9A961] font-semibold">Training guide</div>
          <div className="font-serif text-xl sm:text-2xl text-[#0A1F44] mt-0.5">Mastering the Vetting Process</div>
          <p className="text-slate-600 text-sm mt-1">Study the vetting process and learn how to guide someone through each step, from the first conversation to supporting a new partner.</p>
        </div>
        <ArrowRight className="w-5 h-5 text-[#C9A961] mt-1 transition-transform group-hover:translate-x-1" />
      </div>
    </Link>
  );
}
